import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import DefaultLayout from '../../layout/DefaultLayout';
import UserBlockedTable from './UserBlockedTable';


const BlockedUsers = () => {

  return (
    <DefaultLayout>
      <BreadcrumbTwo/>
      <UserBlockedTable/>
    </DefaultLayout>
  );
};

export default BlockedUsers;
